export default {"src":"/_next/static/image/public/images/ic_wishlist_hc.45435eae970fc43d1c4e07df8484f77b.svg","height":38,"width":38};